import {useEffect, useRef, useState} from "react";
import "./Carousel.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Countdown from "./Countdown/Countdown";

const Carousel = ({events, content}) => {
    const carousel = useRef();
    const [count, setCount] = useState(0);



    const incrementCarousel = delta => {
        if (!carousel.current) return;

        const width = carousel.current.offsetWidth;

        if (count + delta > events.length - 1) {
            setCount(0);
            for (let i = 0; i < events.length; i++) {
                document.getElementById("carousel-indicator-" + i).classList.remove("active");
                if (i === 0) {
                    document.getElementById("carousel-indicator-" + 0).classList.add("active");
                }
            }
            carousel.current.scrollTo(0, 0);
            return;
        } else if (count + delta < 0) {
            setCount(events.length - 1);
            for (let i = 0; i < events.length; i++) {
                document.getElementById("carousel-indicator-" + i).classList.remove("active");
                if (i === events.length - 1) {
                    document.getElementById("carousel-indicator-" + i).classList.add("active");
                }
            }
            carousel.current.scrollTo(width * events.length - 1, 0);
            return;
        }

        carousel.current.scrollTo(
            carousel.current.scrollLeft + width * delta,
            0
        );
        setCount(c => c + delta);
        for (let i = 0; i < events.length; i++) {
            document.getElementById("carousel-indicator-" + i).classList.remove("active");
            if (i === count + delta) {
                document.getElementById("carousel-indicator-" + i).classList.add("active");
            }
        }
    };

    return (
        <div className="carousel-with-indicators">
            <div className="carousel-with-controls">
                {events.length <= 1 ? <></> : <div className="carousel-btn left-btn" onClick={() => incrementCarousel(-1)}/> }
                <div className="carousel-container"     >
                    {events.length === 0 ? <p>{content.noEvents}</p> :
                        <div className="carousel" ref={carousel}>
                        {events.map((event, idx) => (
                            <div
                                key={`${idx}-${event}`}
                                className={
                                    idx === count ? "carousel-item active" : "carousel-item"
                                }
                            >
                                <div className="carousel-card-upper-section">
                                    <Countdown event={event} content={content}/>
                                </div>
                                <div className="carousel-card-lower-section">
                                    <div className="carousel-card-lower-section-right-container">
                                        <h2>{content.eventTile}</h2>
                                        <h3>{(new Date(event.date)).toLocaleDateString()} {event.startTime.slice(0, -3)} - {event.endTime.slice(0, -3)} {content.atText} {event.location}</h3>
                                        <a href={event.mapsLink}>
                                            <button><span style={{padding: "5px"}}>{content.directions}</span>
                                                <svg style={{height: "20px", padding: "5px", fill: "var(--text)"}}
                                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path
                                                        d="M218 32H58C40.3 32 26 46.3 26 64v64c0 17.7 14.3 32 32 32H435.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H282c0-17.7-14.3-32-32-32s-32 14.3-32 32zM474 256c0-17.7-14.3-32-32-32H282V192H218v32H64.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H442c17.7 0 32-14.3 32-32V256zM282 480V384H218v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"/>
                                                </svg>
                                            </button>
                                        </a>
                                    </div>
                                </div>


                                <img src={"../../assets/images/" + event.image} className="event-image"/>
                            </div>
                        ))}

                    </div>
                    }
                </div>
                {events.length <= 1 ? <></> : <div className="carousel-btn right-btn" onClick={() => incrementCarousel(1)}/>}
            </div>
            <div className="carousel-indicators-controls">
                {events.length <= 1 ? <></> : <div className="carousel-btn left-btn carousel-btn-small" onClick={() => incrementCarousel(-1)}/>}
                <div>
                    <ol className="carousel-indicators">
                        {events.map((event, idx) => (
                            <li id={"carousel-indicator-" + idx} className={idx === 0 ? "active" : ""}></li>
                        ))}
                    </ol>
                </div>
                {events.length <= 1 ? <></> : <div className="carousel-btn right-btn carousel-btn-small" onClick={() => incrementCarousel(1)}/> }
            </div>
        </div>
    );
};

export default Carousel;
